<template>
  <div class="main">
    <div
      class="preloader"
      v-if="file"
    >
        <h2>Пожалуйста, подождите, идет обработка фото</h2>
        <img src="@/assets/icon/preloader.svg" alt="">
    </div>
    <div
      class="dropzone-container"
      @dragover="dragover"
      @dragleave="dragleave"
      @drop="drop"
      v-if="!file"
    >
      <div class="upload_icons_block">
        <img src="@/assets/icon/upload.svg" alt="">
        <img class='camera_icon' src="@/assets/icon/camera.svg" alt="">
      </div>

      <div class="file-extensions-list">
        <span>
          .png
        </span>
        <span>
          .jpg
        </span>
        <span>
          .jpeg
        </span>
        <span>
          .tiff
        </span>
        <span>
          .bmp
        </span>
      </div>
      <input
        type="file"
        name="file"
        id="fileInput"
        class="hidden-input"
        @change="onChange"
        ref="file"
        accept="image/*"
		capture="camera"
      />
    <input
        type="file"
        name="mobile_file"
        id="mobile_fileInput"
        class="hidden-input"
        ref="mobile_file"
         @change="onMobileChange"
         accept="image/*"
    />
      <label for="fileInput" class='dropfile_mobile'>
        Сделать снимок
      </label>
      <label for="mobile_fileInput" class='dropfile_mobile'>
        Загрузить из галереи
      </label>
      <label for="fileInput" class="file-label">
        <div v-if="isDragging">Отпустите, чтобы перетащить сюда файлы.</div>
        <div v-else>Перетащите файлы в поле или <u>нажмите.</u></div>
      </label>
      <label for="fileInput" class="file-label">
        <div class="button">
          Загрузить файлы
        </div>
      </label>
    </div>
    <div class="preview-container mt-4" id="image_card">
      <div class="preview-card">
        <div>
          <canvas id="c" ref="can" width="800" height="700"></canvas>
          <!--<img class="preview-img" id="preview-img" :src="file" />-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import {fabric} from "fabric";
import Perspective from "perspectivejs";
import {mapMutations} from 'vuex';
import api from "../services/config.js";

export default {
    data() {
        return {
            isDragging: false,
            file: null,
            maxFileSize: 10 * 1024 * 1024,
            poligons: [],
            poligon_points: [],
            canvas: null,
        };
    },
    mounted() {
    },
    beforeUnmount() {
    },
    computed: {
        isMobileOrTablet() {
            let check = false;
            (function (a) {
                if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
            })(navigator.userAgent || navigator.vendor || window.opera);
            return check;
        }
    },
    methods: {
        ...mapMutations(["setImage", "setDoorsPos"]),
        onChange() {
            let input = this.$refs.file;
                let file = input.files;
                //если есть загруженный файл
                if (file && file[0]) {
                    //если размер меньше 10 мб
                    if (file[0].size < this.maxFileSize) {
                        let reader = new FileReader();
                        reader.onload = (e) => {
                            let img = new Image();
                            img.onload = () => {
                                // Отправляем запрос на бэк
                                const formData = new FormData();
                                formData.append('image', file[0]);

                                fetch(api.detect.get, { method: "POST", body:formData, headers: {"Accept": "application/json"} }).then((responce) => {
                                    responce.json().then((data) => {
                                        // Если ошибка
                                        if(data.errors)
                                            return;
                                        const polygons = [];
                                        for (const [key, value] of Object.entries(data)) {
                                            // Если не нашлось дверей
                                            if(!value.length)
                                                break;

                                            const poly = [
                                                {
                                                    x: value[0][0][0],
                                                    y: value[0][0][1],
                                                },
                                                {
                                                    x: value[0][3][0],
                                                    y: value[0][3][1],
                                                },
                                                {
                                                    x: value[0][2][0],
                                                    y: value[0][2][1],
                                                },
                                                {
                                                    x: value[0][1][0],
                                                    y: value[0][1][1],
                                                }
                                            ];

                                            polygons.push(poly);
                                        }
                                        this.setDoorsPos(polygons);
                                    }).finally(() => {
                                        this.setImage(img);
                                        this.$router.push({name: 'choice'});
                                    });
                                });
                            };
                            img.src = e.target.result;
                            this.file = img;

                        };
                        reader.readAsDataURL(file[0]);
                    } else {
                        this.$swal.fire({
                            icon: "error",
                            text: "Размер изображения не должен превышать 10МБ!",
                            title: "Ошибка"
                        })
                    }
                } else {
                    this.$swal.fire({
                        icon: "error",
                        text: "Изображение не найдено! Попробуйте обновить и страницу и загрузить заново.",
                        title: "Ошибка"
                    })
                }
        },
        onMobileChange(e) {
            e.preventDefault()
            this.$refs.file.files = this.$refs.mobile_file.files
            this.onChange();
        },
        dragover(e) {
            e.preventDefault();
            this.isDragging = true;
        },
        dragleave() {
            this.isDragging = false;
        },
        drop(e) {
            e.preventDefault();
            this.$refs.file.files = e.dataTransfer.files;
            this.onChange();
            this.isDragging = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.file-label{

  margin-top: 15px;

  .button{
    display: inline-block;
  }
}
.camera_icon{
  display: none;
}
.dropfile_mobile{
  display: none;
  padding: 10px 35px;
  background: #2285C4;
  border-radius: 6px;
  margin-bottom: 10px;
  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 140.5%;
  /* identical to box height, or 24px */
  text-align: center;
  color: #FFFFFF;
  text-decoration: none;
}
.main {
  flex-grow: 1;
  align-items: center;
  width: 100%;
  justify-content: center;
  text-align: center;
  margin-top: 10px;
}

.preloader {
    margin-top: 65px;
}

.dropzone-container {
  padding: 44px;
  border: 2px dashed #3498DB;
  border-radius: 10px;
  .file-extensions-list{
    margin-top: 10px;
    display: flex;
    justify-content: center;
    span{
      font-style: normal;
      font-weight: 300;
      font-size: 17px;
      line-height: 140.5%;
      /* identical to box height, or 24px */
      text-align: center;
      text-transform: uppercase;
      /* grey */
      color: #969696;
      margin-right: 10px;
      margin-bottom: 20px;
    }
  }
}

.hidden-input {
  opacity: 0;
  overflow: hidden;
  position: absolute;
  width: 1px;
  height: 1px;
}

.file-label {
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  line-height: 140.5%;
  /* or 31px */
  text-align: center;
  color: #111111;
  display: block;
  cursor: pointer;
}

.preview-container {
  display: none;
  margin-top: 2rem;
}

.preview-card {
  display: flex;
}

.preview-img {
  border-radius: 5px;
}

@media screen and (max-width: 1000px){

  .dropzone-container{
    background: #fff;
    margin-top: 40px;
  }
  .dropfile_mobile{
    display: block;
  }
  .file-label{
    display: none;
  }
  .camera_icon{
    display: inline-block;
    border-left: 2px solid #3498DB;
  }
  .upload_icons_block{
    display: flex;
    justify-content: center;
    img{
      padding-left: 20px;
      padding-right: 20px;
    }
  }
}

@media screen and (max-width: 375px){
  .dropzone-container{
    padding: 20px
  }

  .dropfile_mobile{
    padding: 10px 35px;
    background: #2285C4;
    border-radius: 6px;
    margin-bottom: 10px;
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 140.5%;
    text-align: center;
    color: #FFFFFF;
    text-decoration: none;
  }

  .dropzone-container .file-extensions-list{
    display: block;
    margin-bottom: 10px;
  }
}
</style>
